import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'workflow-exit-modal',
	template: require('./workflow-exit-modal.html'),
	styles: [require('./workflow-exit-modal.scss')]
})
export class WorkflowExitModalComponent {
	@Input() nextPage: string;
	@Output() changePage: EventEmitter<boolean> = new EventEmitter();

	exitWithSaving(isSaving) {
		this.changePage.emit(isSaving);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/workflow-exit-modal/workflow-exit-modal.ts